var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "test" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("el-input", {
          ref: "input",
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.getBoxList.apply(null, arguments)
            }
          },
          model: {
            value: _vm.inputBoxList,
            callback: function($$v) {
              _vm.inputBoxList = $$v
            },
            expression: "inputBoxList"
          }
        }),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.completeStock }
          },
          [_vm._v("备货完成")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "boxList" },
      _vm._l(_vm.boxcodesList, function(item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "boxcodes",
            class: { active: _vm.selectBox(item.label) },
            on: {
              click: function($event) {
                return _vm.addboxCode(item.label)
              }
            }
          },
          [_vm._v(_vm._s(item.label))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f56c616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f56c616","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/test.vue
// module id = null
// module chunks = 